var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoErrorImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 113,
    viewBox: "0 0 120 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1759_2267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6958 112.904C88.2141 112.904 111.333 89.7855 111.333 61.2673C111.333 32.749 88.2141 9.63037 59.6958 9.63037C31.1776 9.63037 8.05896 32.749 8.05896 61.2673C8.05896 89.7855 31.1776 112.904 59.6958 112.904Z",
    fill: "url(#paint0_linear_1759_2267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58508 68.2849C4.11332 72.7179 4.58508 78.0087 7.42347 84.863C12.0242 95.9319 22.4888 102.513 34.2439 100.162C44.3187 98.1465 58.343 93.6043 71.7473 83.397C85.0036 73.3145 79.627 63.6725 79.627 63.6725C79.627 63.6725 85.1127 53.4145 77.3851 49.3597C77.3851 49.3597 79.9389 37.203 68.753 38.4038C68.753 38.4038 65.86 29.2024 56.3701 33.6862C46.8802 38.1699 42.3692 40.6613 42.3692 40.6613C42.3692 40.6613 39.5737 19.4942 28.7738 22.1143C28.7738 22.1143 25.5143 22.9837 26.2512 31.3858C26.9881 39.7879 28.419 50.7867 20.1027 56.1087C16.7385 58.2822 13.055 59.9161 9.18577 60.9511C6.14463 61.7465 4.90089 65.1775 4.58508 68.2849Z",
    fill: "#FEFEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66724 60.1558C8.66724 60.1558 24.2082 57.7073 26.4306 48.658C28.6529 39.6086 24.0055 24.7812 26.9764 23.1163C29.9474 21.4515 36.9927 19.8608 39.9363 31.8694C42.88 43.8779 41.2853 52.1709 46.5644 49.7613C51.0599 47.7066 52.5414 45.8196 54.4909 43.4452",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6752 41.4724C41.6752 41.4724 61.3841 27.4364 66.6515 34.7546C71.9189 42.0728 53.1262 59.2903 53.1262 59.2903",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7335 38.404C68.7335 38.404 75.6813 37.6242 76.9679 44.5954C78.2546 51.5666 65.1075 62.3159 61.0721 66.2654",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3832 49.0635C76.3832 49.0635 83.2374 50.3267 81.3776 57.9997C79.5179 65.6727 63.0529 77.6384 63.0529 77.6384",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1123 62.9087C79.1123 62.9087 87.3234 72.8821 67.6262 86.5009C47.929 100.12 23.5687 100.74 23.5687 100.74",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2402 16.8976L46.3226 3.271",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3584 14.6285L21.6232 1.75439",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0345 21.4905L13.1002 16.999",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37093 14.3595L4.40576 12.1138",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.967 76.1844C94.7089 76.3005 97.4392 75.7637 99.933 74.6181C102.427 73.4726 104.613 71.751 106.311 69.5953C112.179 62.1874 107.145 61.1191 120 52.6741C120 52.6741 112.124 45.929 106.245 46.3345C100.365 46.74 97.9128 51.7383 97.1253 55.2122C96.3377 58.6862 99.9403 70.5193 91.967 76.1844Z",
    fill: "#B9E702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89525 39.5268C4.24979 41.1527 1.11508 40.8641 0.183246 38.2012C-0.748589 35.5383 1.91435 33.2262 7.08038 33.3627C12.2464 33.4991 17.4826 34.162 18.625 36.3258C19.7674 38.4897 13.9853 36.8054 7.89525 39.5268Z",
    fill: "#B9E702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8797 15.3735H95.6281V18.6252H98.8797V15.3735Z",
    fill: "#FF00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3256 45.3198L88.9413 47.5308L91.1523 49.9151L93.5366 47.7041L91.3256 45.3198Z",
    fill: "#44C7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01217 26.6138H4.7605V29.8654H8.01217V26.6138Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1778 11.9462C67.1778 11.9462 57.9882 17.0148 54.3115 22.8319C54.3115 22.8319 53.6799 13.8138 58.4755 5.71582C58.4755 5.71582 64.1445 5.70803 67.1778 11.9462Z",
    fill: "#FFE600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1759_2267",
    x1: 8.05896,
    y1: 9.63037,
    x2: 121.799,
    y2: 22.8491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B87FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#486BFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1759_2267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 112.904,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoErrorImg);
export default __webpack_public_path__ + "static/media/noErrorImg.52dfd6fb4d6372313351708c0f17c829.svg";
export { ForwardRef as ReactComponent };